import { css } from "@emotion/react";
export const page = css`
  overflow: hidden;
`;

export const text = css`
  color: red;
  font-weight: 500;
`;

export const heroContainer = css`
  position: relative;
  height: 100%;
`;

export const brandContainer = css`
  @media (min-width: 600px) {
    width: 604px;
  }
`;

export const galleryBackground = css`
  background: var(--gray300);
`;

export const FooterBackground = css`
  background: var(--color-secondary);
`;

export const footerBackgroundImage = css`
  background-position: center;
  /* safari対応のためimportantを用いる */
  &::before,
  &::after {
    background-size: 200% !important;
  }
  @media (min-width: 600px) {
    /* gatsby-background-imageにレスポンシブなcssを適用するために疑似要素とimportantを用いる */
    &::before,
    &::after {
      background-size: cover !important;
    }
  }
`;

export const replayIcon = css`
  margin-right: 8px;
`;

export const replayButton = css`
  position: absolute;
  right: 32px;
  bottom: 48px;
  font-size: 16px;
  font-weight: 600;
  line-height: 27px;
  color: var(--color-secondary);
  :hover {
    opacity: 0.8;
    transition: all 0.5s;
  }

  @media (min-width: 965px) {
    right: 0;
  }
`;
